import React, {Fragment, PureComponent, ReactNode} from "react";
import {Splide, SplideSlide} from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import {Image, ImageSize, PartnerConfig} from "@App/types";


type GarageProfileHeroSliderProps = {
    images: Image[],
    alt: string,
    id: string | number,
    partner: PartnerConfig
};

export class GarageProfileHeroSlider extends PureComponent<GarageProfileHeroSliderProps> {

    render(): ReactNode {
        const {
            images,
            alt,
            id,
            partner
        } = this.props

        return (
            <div className={"garageListItem_slider -mx-6 lg:mx-0 col-span-full z-10"}>
                <Splide options={{
                    rewind: true,
                    height: 320,
                    breakpoints: {
                        767 : {
                            height: 218,
                        }
                    },
                    classes: {
                        arrows: 'splide__arrows hidden md:block z-10',
                    },
                    type: 'slide',
                    lazyLoad: 'sequential',
                    preloadPages: 0,
                    perPage: 1,
                    arrows: images.length > 1,
                    drag: images.length > 1
                }}>
                    {images.length > 0 && images.map((image: any, index: number) => (
                        <Fragment key={id + 'profileSlider' + index}>
                            {image.sizes && (
                            <SplideSlide key={id + 'profileSlider' + index} className={'lg:rounded-l-md z-10'}>
                                <picture className={'lg:rounded-md w-full h-full object-cover'}>
                                    {image.sizes.filter((size:ImageSize) => size.name.includes('profil')).map((size: any, innerIndex: number) => (
                                        <source key={id + 'profileSlider' + innerIndex} media={`${size.media}`} srcSet={`${process.env.NEXT_PUBLIC_IMG_SRC + size.path}`} width={`${size.width}`} height={`${size.height}`}/>
                                    ))}
                                    <img className={'lg:rounded-md w-full h-full object-cover'}
                                         loading={index < 2 ? 'eager' : 'lazy'}
                                         src={process.env.NEXT_PUBLIC_IMG_SRC + image.sizes[0].path}
                                         height={image.sizes[0].height}
                                         width={image.sizes[0].width}
                                         alt={index == 0 ? alt : ''}/>
                                </picture>
                            </SplideSlide>
                            )}
                        </Fragment>
                    ))}
                    {images.length === 0 || images[0]?.sizes === null && (
                        <SplideSlide className={'lg:rounded-l-md z-10'}>
                            <img className={'rounded-md w-full h-full object-cover h-[218px] md:h-[320px]'}
                                 src={process.env.NEXT_PUBLIC_BACKEND_URL + partner.fallbackImage}
                                 alt={'Werkstatt'}/>
                        </SplideSlide>
                    )}
                </Splide>
            </div>
        );
    }
}
